<template>
  <div class="index" v-cloak>
    <div class="index-bg" :style="{backgroundImage:`url(${require('@assets/images/dywfl/background.jpg')})`}">
      <!-- <img src="@assets/images/dywfl/background.jpg" alt=""> -->
    </div>
    <div class="back-btn iconfont icon-tishengfenzhi" v-if="history_pid.length>0" @click="preCate"></div>
    <!-- 二级 -->
    <div class="level2" v-if="cate_list[0].level == 2">
      <div class="cate-list">
        <div class="cate-item" v-for="(item,index) in cate_list" @click="chooseCate(index)">
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>

    <!-- 三级 -->
    <div class="level3" v-if="cate_list[0].level >= 3">
      <div class="cate-list">
        <div class="cate-item" v-for="(item,index) in cate_list" @click="chooseCate(index)">
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>
    <div class="index-botom" style="height: 1rem"></div>
  </div>
</template>

<script>
import { getHomeData, getShare, follow, getFulianCate } from "@api/public";

import cookie from "@utils/store/cookie";

export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
      pid: 0, //分类id
      cate_list: [], //分类列表
      history_pid:[],//分类历史
    };
  },
  mounted: function () {
    let that = this;
    // let history_pid = that.history_pid;
    that.pid = that.$route.query.pid;
    // history_pid.push()
    // that.history_pid = history_pid;
    that.getFulianCate();
  },
  methods: {
    reload(){
      let that = this;
      that.pid = that.$route.query.pid;
      that.getFulianCate();
    },
    getFulianCate: function () {
      let that = this;
      let pid = that.pid;
      getFulianCate(pid).then((res) => {
        let list = res.data;
        if(res.data.length <=0){
          this.$router.push({ path: "/news/list",query: { id: pid } });
        }
        that.$set(that, "cate_list", res.data);
      });
    },
    chooseCate:function(index){
      let that = this;
      let cate_list = that.cate_list;
      let cate_data = cate_list[index];
      that.history_pid.push(that.pid);
      that.pid = cate_data.id;
      this.getFulianCate();
    },
    preCate:function(){
      let that = this;
      let history_pid = that.history_pid;
      that.pid = history_pid[history_pid.length-1];
      history_pid.splice(history_pid.length-1,1);
      that.getFulianCate();
    }
  },
};
</script>
<style scoped>
.index-bg{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
}
.level2 {
  
}
.level2 .cate-list {
  display:flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1rem .4rem;
}
.level2 .cate-list .cate-item{
  width: 50%;
}
.cate-item img{
  width: 100%;
  vertical-align: bottom;
}

.level3 .cate-list {
  /* display:flex;
  justify-content: space-between;
  flex-wrap: wrap; */
  padding: 1rem .4rem;
}
.level3 .cate-list .cate-item{
  width: 100%;
}
.level3 .cate-list .cate-item~.cate-item{
  margin-top: .5rem;
}
.back-btn{
  position: absolute;
  top: .5rem;
  left: .4rem;
  transform: translate(0,-50%) rotate(-90deg);
  color: #666;
}
</style>
